/*
 * Oeffnet die gesetzliche Gewaehrleistungsmitteilung.
 *
 * Der Praxisleitfaden der Kommission sieht genau das vor: ein Satz, der auf
 * die Gewaehrleistungsrechte hinweist, und die Mitteilung erscheint beim
 * ersten Klick. Sie muss dabei in voller Groesse und lesbar erscheinen —
 * deshalb ein modaler Dialog und keine Vorschau.
 *
 * Bewusst ohne Abhaengigkeiten und ohne Bindung an Horizons Drawer-Komponente:
 * das hier ist eine Pflichtfunktion und soll auch dann noch laufen, wenn am
 * Theme etwas umgebaut wird.
 */
(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var opener = target.closest('[data-rxk-gl-open]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('data-rxk-gl-open'));
      if (!dialog) return;
      // showModal() faengt Fokus und Escape selbst ab. Fehlt es (sehr alte
      // Browser), bleibt der Dialog per open-Attribut wenigstens sichtbar.
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      return;
    }

    if (target.closest('[data-rxk-gl-close]')) {
      var open = target.closest('dialog');
      if (!open) return;
      if (typeof open.close === 'function') open.close();
      else open.removeAttribute('open');
      return;
    }

    // Klick auf die Flaeche neben dem Blatt schliesst ebenfalls.
    if (target.classList && target.classList.contains('rxk-gl__dialog')) {
      if (typeof target.close === 'function') target.close();
    }
  });
})();
